 
import axios from 'axios';
import { getToken } from '@/utils/auth'
import { MessageBox } from 'element-ui'
import store from '@/store'

import Vue from 'vue'
// 基本配置
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API||'http://192.168.1.27:8080', // 根据实际情况修改API地址
  timeout: 60000 // 设置超时时间，单位为ms
});
 

// 请求拦截器  
instance.interceptors.request.use(config => {  
  // 在发送请求之前做些什么，比如添加token  
  const token = getToken(); // 从auth工具中获取token  
  
  if (token) {  
    // 如果token存在，则将其添加到请求头中  
    config.headers['Authorization'] = `Bearer ${token}`;
  }else{
    store.dispatch('FedLogOut')
  }
  
  // 添加多语言支持
  const language = store.getters.language || 'en';
  config.headers['Accept-Language'] = language;
  
  // 返回配置对象，以便继续发送请求  
  return config;  
}, error => {  
  // 对请求错误做些什么  
  return Promise.reject(error);  
});  
 
//响应拦截处理  响应拦截器：包含两个函数（一个是成功返回的函数，一个是失败的返回的函数）
instance.interceptors.response.use(res => {
    if (res.headers['content-type'] === 'application/pdf;charset=UTF-8') {  
      // 处理 PDF 响应  
      const blob = new Blob([res.data], { type: 'application/pdf;charset=UTF-8' });
      const url = window.URL.createObjectURL(blob);  
      // 例如，你可以在这里打开一个新的窗口或标签页来显示 PDF  
      window.open(url);  
      return 

      // const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));  
      // const link = document.createElement('a');  
      // link.href = url;  
      // link.setAttribute('download', 'filename.pdf'); // 设置下载的文件名  
      // document.body.appendChild(link);  
      // link.click(); // 触发下载  
      // document.body.removeChild(link);  
      // window.URL.revokeObjectURL(url); 
    } 
    // 我们一般在这里处理，请求成功后的错误状态码 例如状态码是500，404，403
    // res 是所有相应的信息
    return res.data
}, err => {
  let { res } = err
  if (res) {
    switch (res.status) {
      case 401:
        // （根据状态去进行提示，以下状态都是O）
        break
      case 403:
        break
      case 404:
        break
      case 500:
        break
    }
  } else {
    if (!window.navigator.onLine) {
      //断网处理：跳转到断网页面
      return
    }
  }
  // 服务器响应发生错误
  return Promise.reject(err)
})
 
 
// 响应拦截器
instance.interceptors.response.use(async response => {
  const data = response;
 
  if (data && data.code !== 200) { // 根据接口返回的状态码判断是否有错误
       if(data && data.code === 401){
        const result = await new Promise(resolve => {
          const vm = new Vue() // 创建临时实例
          MessageBox.confirm('You have not logged in or your login has expired. Please log in first.', 'System Tips', { confirmButtonText: 'Login', cancelButtonText: 'cancel', type: 'warning' }).then(() => {
            vm.$login.show({})
          }).catch(() => {
            // 用户点击取消时调用登出操作
            store.dispatch('user/LogOut')
            // window.location.reload()
          });
        })
        return Promise.reject(new Error(data.msg||data.message));
      }
      // alert(`Error code ${data.code}: ${data.message}`); // 自定义错误提示
      return Promise.reject(new Error(data.msg||data.message));
  } else {
      return data;
  }
  
}, error => {
  return Promise.reject(error);
});
 
export default instance;
 